import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";

export default function NotFound() {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = document.title;
    document.title = "Page not found | Cresway Media";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => { document.title = prev; meta.remove(); };
  }, []);

  return (
    <section data-testid="not-found-page" className="relative mx-auto flex min-h-[70vh] max-w-7xl flex-col justify-center px-5 pb-24 pt-12 sm:px-8 lg:px-12">
      <p aria-hidden className="pointer-events-none select-none font-display text-[38vw] font-extrabold leading-none tracking-[-0.06em] text-[#0A0A0A]/[0.05] sm:text-[24vw] lg:absolute lg:right-8 lg:top-1/2 lg:-translate-y-1/2 lg:text-[18rem]">404</p>
      <div className="relative -mt-[18vw] sm:-mt-[10vw] lg:mt-0">
        <p className="font-mono-label text-xs uppercase tracking-[0.25em] text-[#E62314]" data-testid="not-found-code">Error 404</p>
        <h1 data-testid="not-found-heading" className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.03em] sm:text-5xl lg:text-6xl">
          This page doesn't exist
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-[#3a3836] sm:text-lg" data-testid="not-found-message">
          The page <span className="break-words font-semibold text-[#0A0A0A]">{pathname}</span> couldn't be found. It may have been moved or removed, or the link may be wrong.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <Link to="/" data-testid="not-found-home" className="inline-flex items-center gap-2 bg-[#0A0A0A] px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-[#E62314]">
            <ArrowLeft className="h-4 w-4" />Back to home
          </Link>
          <Link to="/contact" data-testid="not-found-contact" className="inline-flex items-center gap-2 border border-[#0A0A0A] px-6 py-3.5 text-sm font-bold transition-colors hover:bg-[#0A0A0A] hover:text-white">
            <Mail className="h-4 w-4" />Contact us
          </Link>
        </div>
      </div>
    </section>
  );
}
